import { Component, OnInit } from '@angular/core';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { QueryParamsService } from 'src/app/services/query-params.service';

@Component({
  selector: 'app-association-purchase-order',
  templateUrl: './association-purchase-order.component.html',
  styleUrls: ['./association-purchase-order.component.scss']
})
export class AssociationPurchaseOrderComponent implements OnInit{
  permissionType = PermissionTypeEnum;
  history = 0;

  constructor(
    private authService: AuthenticationService,
    private queryParamsService: QueryParamsService

  )
  {
    var permissions = authService.getPermissions();
  }

  ngOnInit(): void {
    this.history = this.queryParamsService.getNumberParam("history", 0);
  }

  updateIndexParam(value: any) {
    if (value==this.history) {
      return;
    }
    this.queryParamsService.setParams({
      history: value,
    });
  }
}
